import { render, staticRenderFns } from "./playerList.vue?vue&type=template&id=ba94d52c&scoped=true"
import script from "./playerList.vue?vue&type=script&lang=js"
export * from "./playerList.vue?vue&type=script&lang=js"
import style0 from "./playerList.vue?vue&type=style&index=0&id=ba94d52c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba94d52c",
  null
  
)

export default component.exports